import React, { useState } from 'react'
import Layout from '../../layout/Layout'
import styles from './AboutUs.module.scss'
import Breadcrumbs from '../../global/Components/Breadcrumb/Breadcrumb'
import { Col, Row } from 'reactstrap'
import SEO from '../../global/Components/SEO/SEO'


export default function AboutUs() {


    

  return (
    <>
    <SEO title={'About us'} />
        <Layout>
            <div className={`${styles.pageCover}`}>
                <div className={`${styles.lgtOverlay}`}></div>
                <div className={`container-xxl`}>
                    <div className={`${styles.pageContent} ${styles.pageContentMin} position-relative py-4 d-flex align-items-center`}>
                        <h2 className='text-white fw-bold'>
                            <span className='text-primary'>
                                About{' '}
                            </span>
                            us
                        </h2>
                    </div>

                </div>
            </div>
            <div className={`container-xxl`}>
                <div className={`p-2 p-sm-4 ${styles.about}`} >
                    <Row>
                        <Col>
                            <Breadcrumbs />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={5} className='mb-3'>
                            <h2 className='mb-3 fw-bold'>
                                About Letgo or Trade
                            </h2>
                            <p>
                                Let's face it, we don't really need most of the stuff we own! We forget that true
                                happiness is not in having too many things but having the right things. In fact, the item is
                                just a tool; What matters is the experience that the item gives us. The guitar you haven't
                                picked up for years can create a resource for new experiences for the holiday you've
                                been dreaming of.
                            </p>
                            <p>
                                That's why letgo or trade exists! We work to make new and second-hand shopping
                                faster, simpler, and more fun. Thanks to letgo or trade, you can easily catch the
                                opportunities around you, quickly reach the buyers around you by easily listing items,
                                and experience new experiences with your earnings. And it's FREE and we planned to
                                keep it that way!
                            </p>
                            <p>
                                With letgo or trade we want to create a sustainable future where nothing is thrown away
                                unused or sold at high listing rates with ridiculous success fees.
                            </p>
                            <p>
                                So, what are you waiting for? Make room for life with less stuff!
                            </p>
                        </Col>
                        <Col sm={12} md={7}>
                            <div className={`px-4 mb-3`}>
                                <img  src="about_us.jpeg" className={`img-fluid ${styles.image} w-100`} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    </>
  )
}
